

























import ConfirmationModal from "@/components/ConfirmationModal.vue";
import MapComponent from "@/components/MapComponent.vue";
import { Component, Vue, Watch } from "vue-property-decorator";
import { i18n } from "../main";
import { IOrderForm } from "../utils/interfaces";

@Component({
  components: {
    ConfirmationModal,
    MapComponent,
  },
})
export default class Calculator extends Vue {
  public isModalVisible = false;
  public isSendEmailSuccessful = false;
  public step: number = 0
  public orderForm: IOrderForm = {
    recipientEmail: i18n.t("orderConfirmation.input"),
  };

  public get IrrigationArea(): string {
    return this.$store.getters.lastIrrigationArea?.area.toFixed(2) || "";
  }

  constructor() {
    super();
  }

  @Watch("$store.state.isModalVisible")
  public watchCalculatorForm() {
    this.isModalVisible = this.$store.state.isModalVisible;
  }

  @Watch("$store.state.isSendEmailSuccessful")
  public watchIsSendEmailSuccessful() {
    this.isSendEmailSuccessful = this.$store.state.isSendEmailSuccessful;
  }

  public currentWalktroughText(): string {
    return i18n.t(`walktrough[${this.step}].text`) as string
  }

    public currentWalktroughIcon(): string {
    return i18n.t(`walktrough[${this.step}].icon`) as string
  }

  public closeModal(): void {
    this.isModalVisible = false;
  }

  public sendEmail(): void {
    this.$store.dispatch("sendEmail", this.orderForm);
    this.isModalVisible = false;
  }
}
